import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

import Header from '../Header';
import Footer from '../Footer';
import Toaster from '../Toaster/Toaster';

import history from '../../history';

import SocketContext from '../../core/socketNotifications/SocketContext';
// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    const { isBottomBanner } = this.props;
    return (
      <>
        <Toaster />
        <SocketContext.Consumer>
          {
            socket => (
              <Header location={history?.location?.pathname} socket={socket} />
            )
          }
        </SocketContext.Consumer>
        <main className='homePageBody'>{this.props.children}</main>
        <Footer isBottomBanner={isBottomBanner} />
      </>
    );
  }
}

export default withStyles(normalizeCss, s)(Layout);
